import { Loader2, RefreshCw } from 'lucide-react'
import * as React from 'react'
import { useTexts } from '../../i18l'

/* ─────────────────────────────────────────────────────────────────────────────
 * LoaderLine — coral progress bar that sweeps across the top of its container.
 * Uses the `loading` keyframe defined in _keyframes.scss.
 * ───────────────────────────────────────────────────────────────────────────── */
export function LoaderLine() {
  return (
    <div className="relative h-1 w-full overflow-hidden bg-border/30">
      <div
        className="absolute inset-y-0 w-[30%] bg-primary"
        style={{ animation: 'loading 2s linear infinite' }}
      />
    </div>
  )
}

/* ─────────────────────────────────────────────────────────────────────────────
 * LoaderCircle — centred spinning ring, replaces the legacy 12-dot sk-circle.
 * ───────────────────────────────────────────────────────────────────────────── */
export function LoaderCircle() {
  const { t } = useTexts()
  return (
    <div className="flex items-center justify-center py-16">
      <Loader2 className="h-8 w-8 animate-spin text-primary" aria-label={t.shared.components.loader.loading} />
    </div>
  )
}

/* ─────────────────────────────────────────────────────────────────────────────
 * LoaderInline — small spinning icon for inline use (e.g. button states).
 * ───────────────────────────────────────────────────────────────────────────── */
export function LoaderInline() {
  return (
    <span className="inline-flex">
      <RefreshCw className="inline h-4 w-4 animate-spin" aria-hidden="true" />
    </span>
  )
}

/* ─────────────────────────────────────────────────────────────────────────────
 * LoaderChars — cycling ASCII characters for ultra-lightweight inline loading.
 * ───────────────────────────────────────────────────────────────────────────── */
export function LoaderChars() {
  const chars = ['-', '/', '|', '\\']
  const [index, setIndex] = React.useState(0)

  React.useEffect(() => {
    const id = setInterval(() => {
      setIndex(prev => (prev + 1) % chars.length)
    }, 250)
    return () => clearInterval(id)
  }, [])

  return (
    <span className="font-mono text-xs text-muted-foreground" aria-hidden="true">
      {chars[index]}
    </span>
  )
}
